<div fxLayout="column">
  <div fxFlex fxLayout="row" *ngIf="hasFilter" fxLayoutGap="10"
    fxLayoutAlign="space-between center">
    <!-- Botão customizado (à esquerda) -->
    <div fxFlex="initial" *ngIf="showCustomButton">
      <button
        mat-mini-fab
        [color]="customButtonColor"
        [matTooltip]="customButtonTooltip"
        (click)="customButtonClick.emit()">
        <mat-icon>{{customButtonIcon}}</mat-icon>
      </button>
    </div>

    <!-- Campo de pesquisa (ao centro) -->
    <div fxFlex class="search-input">
      <mat-form-field *ngIf="!hideFilter">
        <input
          matInput
          #input
          (keyup)="applyFilter(filterValue)"
          [(ngModel)]="filterValue"
          (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
          (onModelChange)="keyboardService.onInputChange($event, input)"
          placeholder="Pesquisar" />

        <button mat-icon-button matSuffix (click)="picker.open()"
          *ngIf="showCalendar">
          <mat-icon>calendar_today</mat-icon>
        </button>
        <button mat-icon-button matSuffix
          *ngIf="dateFilterActive && showCalendar" (click)="clearDateFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <!-- Campo auxiliar para o datepicker -->
        <input matInput [matDatepicker]="picker"
          (dateChange)="onDateSelected($event)" style="display: none;" />
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Botão de adicionar (à direita) -->
    <div fxFlex="initial" *ngIf="hasAdd">
      <button mat-fab class="btn-add" *ngIf="hasRefresh"
        (click)="onRefreshButtonClick($event)">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-fab class="btn-add"
        (click)="openNew.emit({ userType: userType })">
        <mat-icon>{{ addIcon }}</mat-icon>
      </button>
    </div>
  </div>

  <div class="mat-elevation-z8">

    <ng-content select="[header]"></ng-content>

    <div class="table-container">
      <!-- Mensagem de nenhum item encontrado -->
      <div *ngIf="!dataSource?.data?.length" class="no-data-message">
        <mat-icon>search_off</mat-icon>
        <span>Nenhum item encontrado</span>
      </div>

      <table mat-table [dataSource]="dataSource" matSort>
        <!-- Checkbox Column -->
        <ng-container *ngIf="hasSelectConfig()" matColumnDef="select" sticky>
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? masterToggle() : null"
              [checked]="isAllSelected()"
              [indeterminate]="isMasterCheckboxIndeterminate()"
              [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? toggleSelection(row) : null"
              [checked]="isSelectAllChecked || selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Position Column -->
        <ng-container *ngFor="let config of configColumns; let idx = index"
          matColumnDef="{{ config.property }}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
            [ngClass]="config.headerClass || ''">
            {{ config.display }}
          </th>

          <td
            mat-cell
            *matCellDef="let element"
            class="{{ config.class }} td_idx_{{ idx }}"
            [attr.data-label]="config.display">
            <!-- LABELS -->
            <!-- LINK -->
            <a
              *ngIf="
                (config.field_type === fieldTypeEnum.LABEL ||
                  config.field_type === fieldTypeEnum.LABEL_CURRENCY ||
                  config.field_type === fieldTypeEnum.LABEL_DATE ||
                  config.field_type === fieldTypeEnum.LABEL_DATE_TIME) &&
                config.link_show
              "
              href="javascript:void()"
              (click)="openShow.emit(element)"
              class="disabled_link_on_web {{activeShowLockClass(element)}} {{activeShowPeopleLockClass(element)}}">
              <span *ngIf="!config.maxLength">{{ getValue(config,
                element[config.property], element) }}</span>
              <span *ngIf="config.maxLength"
                [matTooltip]="(getValue(config, element[config.property], element)?.length || 0) > config.maxLength ? getValue(config, element[config.property], element) : ''">{{
                getValue(config, element[config.property], element) |
                slice:0:config.maxLength }}{{ (getValue(config,
                element[config.property], element)?.length || 0) >
                config.maxLength ?
                '...' : '' }}</span>
            </a>
            <!-- LABEL COMUM -->
            <ng-container
              *ngIf="
                (config.field_type === fieldTypeEnum.LABEL ||
                  config.field_type === fieldTypeEnum.LABEL_CURRENCY ||
                  config.field_type === fieldTypeEnum.LABEL_DATE ||
                  config.field_type === fieldTypeEnum.LABEL_DATE_TIME ||
                  config.field_type === fieldTypeEnum.LABEL_PERCENTAGE) &&
                !config.link_show
              "
              class="{{activeShowLockClass(element)}} {{activeShowPeopleLockClass(element)}}">
              <span *ngIf="!config.maxLength">{{ getValue(config,
                element[config.property], element) }}</span>
              <span *ngIf="config.maxLength"
                [matTooltip]="(getValue(config, element[config.property], element)?.length || 0) > config.maxLength ? getValue(config, element[config.property], element) : ''">{{
                getValue(config, element[config.property], element) |
                slice:0:config.maxLength }}{{ (getValue(config,
                element[config.property], element)?.length || 0) >
                config.maxLength ?
                '...' : '' }}</span>
            </ng-container>
            <!-- LABEL FLAG -->
            <ng-container
              *ngIf="config.field_type === fieldTypeEnum.LABEL_FLAG">
              <span [ngClass]="getStatusClass(element, config)">
                {{ element[config.property] === true ? 'SIM' :
                (element[config.property] === false ? 'NÃO' :
                element[config.property]) }}
              </span>
            </ng-container>

            <ng-container *ngIf="config.field_type === fieldTypeEnum.IMAGE">
              <img class="image-label"
                [src]="getUrl(element[config.property])" />
            </ng-container>

            <!-- COLOR -->
            <ng-container *ngIf="config.field_type === fieldTypeEnum.COLOR">
              <div class="color-display">
                <div class="color-preview"
                  [style.background-color]="element[config.property]"></div>
                <span class="color-value">{{ element[config.property] }}</span>
              </div>
            </ng-container>

            <!-- LABEL_COLORED_BADGE -->
            <ng-container
              *ngIf="config.field_type === fieldTypeEnum.LABEL_COLORED_BADGE">
              <div class="colored-badge"
                *ngIf="getBadgeColor(element, config) !== '#000000'"
                [style.background-color]="getBadgeColor(element, config)"
                [style.color]="getContrastColor(getBadgeColor(element, config))">
                {{ element[config.property] || '' }}
              </div>
              <span *ngIf="getBadgeColor(element, config) === '#000000'">
                {{ element[config.property] || '' }}
              </span>
            </ng-container>
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let row = index">

            <!-- botões para definir o suatus da OS -->

            <button
              *ngIf="showPaymentButton && canShowPaymentButton(element)"
              (click)="openPayment(element)"
              mat-icon-button
              class="btn-payment btn-payment-icon-only"
              [matTooltip]="paymentButtonTooltip"
              [disabled]="element.isPaid === true">
              <mat-icon>{{ paymentButtonIcon }}</mat-icon>
            </button>

            <button
              *ngIf="showOpenChatButton && canShowChatButton(element) && isOutsideMenu('OpenChatButton')"
              mat-icon-button color="primary"
              matTooltip="Chat"
              (click)="openChat(element)">
              <mat-icon>chat</mat-icon>
            </button>

            <button
              *ngIf="element['status'] === ServiceOrdersStatusEnum.APPROVED"
              mat-icon-button color="primary"
              matTooltip="Status Aprovado"
              style="color: darkgreen;"
              (click)="aprovedButton(element)">
              <mat-icon class="fa fa-thumbs-up"></mat-icon>
            </button>

            <button
              *ngIf="showInfo && isOutsideMenu('InfoButton')"
              (click)="infoAction.emit(element)"
              mat-icon-button
              class="btn-info"
              matTooltip="Detalhes">
              <mat-icon>info</mat-icon>
            </button>

            <button
              *ngIf="element['status'] === ServiceOrdersStatusEnum.IN_ANALISING"
              mat-icon-button style="color: rgb(0, 179, 185);"
              matTooltip="Status Em Análise"
              (click)="inAnalisingButton(element)">
              <mat-icon class="fa fa-spinner fa-spin"
                style="animation-duration: 6s;"></mat-icon>
            </button>

            <button
              *ngIf="element['status'] === ServiceOrdersStatusEnum.PENDING"
              mat-icon-button style="color: orange;"
              matTooltip="Status Pendente"
              (click)="pendingButton(element)">
              <mat-icon class="fa fa-hourglass-half fa-spin"
                style="animation: hourglass 6s infinite;"></mat-icon>
              <style>
                @keyframes hourglass {
                  0% { transform: rotate(0deg); }
                  50% { transform: rotate(180deg); }
                  100% { transform: rotate(360deg); }
                }
              </style>
            </button>

            <button
              *ngIf="element['status'] === ServiceOrdersStatusEnum.REJECTED"
              mat-icon-button (click)="pendingButton(element)"
              matTooltip="Status Reprovado"
              style="color: red;"
              [disabled]="element['status'] === 'CANCELADA' || element['status'] === 'REPROVADA' || element['status'] === 'CONCLUIDA'">
              <mat-icon>block</mat-icon>
            </button>

            <button
              *ngIf="element['status'] === ServiceOrdersStatusEnum.CANCELED"
              mat-icon-button (click)="pendingButton(element)"
              matTooltip="Status Cancelado"
              style="color: rgb(255, 0, 0);"
              [disabled]="element['status'] === 'CANCELADA' || element['status'] === 'REPROVADA' || element['status'] === 'CONCLUIDA'">
              <mat-icon>cancel</mat-icon>
            </button>

            <button
              *ngIf="element['status'] === ServiceOrdersStatusEnum.IN_PROGRESS"
              mat-icon-button
              matTooltip="Status Teste"
              style="color: rgb(255, 94, 0);"
              class="btn-laptop-search"
              (click)="inProgressButton(element)">
              <span class="icon-wrapper">
                <mat-icon class="icon-laptop">laptop</mat-icon>
                <mat-icon class="icon-settings">settings</mat-icon>
              </span>
            </button>

            <button
              *ngIf="element['status'] === ServiceOrdersStatusEnum.CONCLUDED"
              mat-icon-button style="color: #00008b;"
              matTooltip="Status Concluído"
              (click)="concludedButton(element)"
              [disabled]=" element['status'] === 'CONCLUIDA'">
              <mat-icon>check_circle</mat-icon>
            </button>

            <!-- botões de usuario master -->
            <button mat-icon-button
              matTooltip="Informações"
              *ngIf="showDescription && isOutsideMenu('DescriptionButton')">
              <mat-icon class="btn-description"
                (click)="descriptionFile(element)">
                info
              </mat-icon>
            </button>

            <button
              *ngIf="showKey && isOutsideMenu('KeyButton')"
              (click)="key.emit(element)"
              mat-icon-button
              class="btn-key"
              matTooltip="Resetar a senha">
              <mat-icon>vpn_key</mat-icon>
            </button>
            <button
              *ngIf="showDashboardButton && isOutsideMenu('DashboardButton')"
              (click)="dashboard.emit(element)"
              mat-icon-button
              class="btn-dashboard"
              matTooltip="Dashboard de Comissões">
              <i class="material-icons">dashboard</i>
            </button>
            <button
              *ngIf="showDownload && element[downloadProperty] && isOutsideMenu('DownloadButton')"
              (click)="download.emit({ fileUrl: element[downloadProperty], element })"
              mat-icon-button
              class="btn-download"
              matTooltip="Download"
              [disabled]="loadingDownloads[element.id]">
              <mat-icon
                *ngIf="!loadingDownloads[element.id]">download</mat-icon>
              <mat-progress-spinner
                *ngIf="loadingDownloads[element.id]"
                class="mat-progress-spinner"
                matTooltip="progresso de download"
                [value]="loadingProgress[element.id]"
                diameter="24"
                mode="determinate"></mat-progress-spinner>
            </button>

            <!-- Novos Botões para Briefing -->
            <button mat-icon-button
              *ngIf="showBriefingActions && isOutsideMenu('BriefingActionsButton')"
              matTooltip="Gerar QR Code"
              (click)="openBriefingQrCode.emit(element)">
              <mat-icon>qr_code</mat-icon>
            </button>

            <button mat-icon-button
              *ngIf="showBriefingActions && isOutsideMenu('BriefingActionsButton')"
              matTooltip="Abrir Formulário"
              (click)="openBriefingForm.emit(element)">
              <mat-icon>link</mat-icon>
            </button>
            <!-- Fim Botões para Briefing -->

            <button
              *ngIf="loadingDownloads[element.id]"
              (click)="cancelDownload.emit(element)"
              mat-icon-button
              class="btn-cancel"
              matTooltip="Cancelar Download">
              <mat-icon>cancel</mat-icon>
            </button>

            <button
              *ngIf="showPlayButton && isOutsideMenu('PlayButton')"
              mat-icon-button color="primary"
              matTooltip="Play"
              (click)="playRow(element)">
              <mat-icon>play_arrow</mat-icon>
            </button>

            <button
              *ngIf="showPdfButton && isOutsideMenu('PdfButton') && element.status !== 'CANCELADA'&& element.status !== 'REPROVADA'"
              mat-icon-button color="primary"
              [matTooltip]="pdfButtonTooltip"
              (click)="pdfShow(element)">
              <mat-icon>{{ pdfButtonIcon }}</mat-icon>
            </button>

            <button
              *ngIf="showContractsButton && isOutsideMenu('ContractsButton')"
              (click)="openContracts(element)"
              mat-icon-button
              class="btn-contracts"
              matTooltip="Visualizar Contrato">
              <mat-icon>description</mat-icon>
            </button>


            <button
              *ngIf="showCancelButton && isOutsideMenu('CancelButton')"
              (click)="cancelParcel.emit(element)"
              mat-icon-button
              class="btn-cancel"
              matTooltip="Cancelar Parcela">
              <mat-icon>cancel</mat-icon>
            </button>

            <!-- Botão de WhatsApp -->
            <button
              *ngIf="showWhatsApp && isOutsideMenu('WhatsAppButton')"
              mat-icon-button
              class="btn-whatsapp"
              matTooltip="WhatsApp"
              (click)="onWhatsApp(element)">
              <img src="assets/img/whatsapp.svg"
                style="width: 25px; height: 25px; padding-bottom: 4px;"
                class="whatsapp-icon">
            </button>

            <!-- Botão de Email -->
            <button
              *ngIf="showEmail && isOutsideMenu('EmailButton')"
              mat-icon-button
              class="btn-email"
              matTooltip="Email"
              (click)="onEmail(element)">
              <mat-icon>email</mat-icon>
            </button>

            <!-- Botão de Atividades -->
            <button
              *ngIf="showActivities && isOutsideMenu('ActivitiesButton')"
              mat-icon-button
              class="btn-activities"
              matTooltip="Atividades"
              (click)="onActivities(element)">
              <mat-icon>event_note</mat-icon>
            </button>



            <button
              *ngIf="showBirthday && isOutsideMenu('BirthdayButton')  &&(!birthdayFilter || birthdayFilter(element))"
              mat-icon-button
              class="btn-birthday"
              matTooltip="Aniversário"
              (click)="onBirthday(element)">
              <mat-icon>cake</mat-icon>
            </button>

            <button
              *ngIf="showActive && element[activeProperty] && isOutsideMenu('ActiveButton')"
              (click)="inactive.emit(element)"
              mat-icon-button
              class="btn-inactive"
              matTooltip="Desativar">
              <i class="material-icons">remove_circle</i>
            </button>
            <button
              *ngIf="showActive && !element[activeProperty] && isOutsideMenu('ActiveButton')"
              (click)="active.emit(element)"
              mat-icon-button
              class="btn-active"
              matTooltip="Ativar">
              <i class="material-icons">check_circle</i>
            </button>

            <!-- Botão para alternar status (ativar/desativar) -->
            <button
              *ngIf="showStatus && isOutsideMenu('StatusButton')"
              mat-icon-button
              [class]="element[statusProperty] ? 'btn-status-active' : 'btn-status-inactive'"
              [matTooltip]="element[statusProperty] ? 'Desativar contato' : 'Ativar contato'"
              (click)="onToggleStatus(element)">
              <mat-icon *ngIf="element[statusProperty]">toggle_on</mat-icon>
              <mat-icon *ngIf="!element[statusProperty]"
                class="inactive-icon">toggle_off</mat-icon>
            </button>

            <!-- Botão de Remoção -->
            <button
              *ngIf="showRemoveButton && isOutsideMenu('RemoveButton')"
              mat-icon-button
              class="btn-remove"
              matTooltip="{{ removeButtonTooltip }}"
              (click)="onRemoveButtonClick(element)">
              <mat-icon>remove</mat-icon>
            </button>

            <button mat-icon-button
              *ngIf="!element.hideShow && !hideShowButton && isOutsideMenu('ShowButton')">
              <mat-icon
                class="btn-show"
                matTooltip="Visualizar"
                (click)="showRow(element, row)">
                remove_red_eye
              </mat-icon>
            </button>
            <button
              mat-icon-button
              *ngIf="!element.hideEdit && isEditableShow && isOutsideMenu('EditButton')"
              [disabled]="!isEditableEnabled"
              class="btn-edit"
              matTooltip="Editar"
              (click)="isEditableEnabled && editRow(element, row)">
              <mat-icon
                [ngClass]="isEditableEnabled ? 'btn-edit' : 'btn-edit:disabled'">
                edit
              </mat-icon>
            </button>

            <button
              mat-icon-button
              *ngIf="!element.hideDelete && isDeletableShow && isOutsideMenu('DeleteButton')"
              [disabled]="!isDeletableEnabled"
              class="btn-delete"
              matTooltip="Excluir"
              (click)="isDeletableEnabled && deleteRow(element, row)">
              <mat-icon
                [ngClass]="isDeletableEnabled ? 'btn-delete' : 'btn-delete:disabled'">
                delete
              </mat-icon>
            </button>

            <button
              *ngIf="showLock &&  isOutsideMenu('LockButton') && isLockActionShow && element[lockProperty] && element.status !== 'CANCELADA' && element.status !== 'REPROVADA' && element.status !== 'CONCLUIDA'"
              [disabled]="!isLockActionEnabled"
              (click)="isLockActionEnabled && lock.emit(element)"
              mat-icon-button
              class="btn-lock"
              matTooltip="Bloquear">
              <i class="material-icons">lock</i>
            </button>
            <button
              *ngIf="showLock && isOutsideMenu('LockButton') && isLockActionShow && !element[lockProperty] && element.status !== 'CANCELADA' && element.status !== 'REPROVADA' && element.status !== 'CONCLUIDA'"
              [disabled]="!isLockActionEnabled"
              (click)="isLockActionEnabled && unlock.emit(element)"
              mat-icon-button
              class="btn-unlock"
              matTooltip="Desbloquear">
              <i class="material-icons">lock_open</i>
            </button>
            <button
              *ngIf="showPeopleLock && element[lockPeopleProperty] && isOutsideMenu('PeopleLockButton')"
              (click)="lockPeople.emit(element)"
              mat-icon-button
              class="btn-lock"
              matTooltip="Bloquear">
              <i class="material-icons">people</i>
            </button>
            <button
              *ngIf="showPeopleLock && !element[lockPeopleProperty] && isOutsideMenu('PeopleLockButton')"
              (click)="unlockPeople.emit(element)"
              mat-icon-button
              class="btn-unlock"
              matTooltip="Desbloquear">
              <i class="material-icons">people</i>
            </button>
            <button
              *ngIf="showInfo && isOutsideMenu('InfoButton') && element[infoProperty] || element.planDescription"
              (click)="infoAction.emit(element)"
              mat-icon-button
              class="btn-info"
              matTooltip="Detalhes">
              <mat-icon class="material-icons">info</mat-icon>
            </button>
            <button
              *ngIf="showRegisterAswersButton && canShowChatButton(element) && isOutsideMenu('RegisterAswersButton') 
              && (element['briefing.typeDescription'] === 'CADASTRO DO CLIENTE' || element['briefing.typeDescription'] === 'CADASTRO DE PARCEIRO') && element['answers'].registered === false"
              mat-icon-button color="primary" class="btn-inside-menu"
              matTooltip="Gerar Cadastro"
              (click)="RegisterCustomers(element)">
              <mat-icon>manage_accounts</mat-icon>
            </button>
            <button
              *ngIf="showDocumentPhoto && isOutsideMenu('DocumentPhotoButton')"
              (click)="DocumentPhoto.emit(element)"
              mat-icon-button
              class="btn-info"
              matTooltip="Foto do Documento">
              <i class="material-icons">camera_alt</i>
            </button>
            <ng-container *ngFor="let btn of buttons">
              <button
                *ngIf="(!btn.isVisible || btn.isVisible(element)) && !btn.isInsideMenu"
                (click)="onButtonClick(btn.action, element)"
                mat-icon-button
                [matTooltip]="btn.tooltip"
                [class]="btn.class">
                <mat-icon>{{ btn.icon }}</mat-icon>
              </button>
            </ng-container>
            <button mat-icon-button [matMenuTriggerFor]="menu"
              aria-label="Example icon-button with a menu"
              *ngIf="hasActionMenu()">
              <mat-icon>more_vert</mat-icon>
            </button>

            <!-- Botões dentro do Menu -->
            <mat-menu #menu="matMenu">

              <ng-container *ngFor="let btn of buttons">
                <button
                  *ngIf="(!btn.isVisible || btn.isVisible(element)) && btn.isInsideMenu"
                  (click)="onButtonClick(btn.action, element)"
                  mat-menu-item class="btn-description"
                  [class]="btn.class">
                  <mat-icon class="btn-description">{{ btn.icon }}</mat-icon>
                  <span>{{btn.tooltip}}</span>
                </button>
              </ng-container>
              <!-- Botão de Chat Menu -->
              <button
                *ngIf="showOpenChatButton && canShowChatButton(element) && isInsideMenu('OpenChatButton')"
                mat-menu-item color="primary" class="btn-inside-menu"
                (click)="openChat(element)">
                <mat-icon>chat</mat-icon>
                <span>Chat</span>
              </button>

              <!-- botão de descrição dentro do Menu-->
              <button mat-menu-item
                (click)="descriptionFile(element)"
                *ngIf="showDescription && isInsideMenu('DescriptionButton')">
                <mat-icon class="btn-description">
                  info
                </mat-icon>
                <span>Informações</span>
              </button>
              <!-- Botão da chave dentro do Menu -->
              <button
                *ngIf="showKey && isInsideMenu('KeyButton')"
                (click)="key.emit(element)"
                mat-menu-item
                class="btn-key">
                <mat-icon class="btn-key">vpn_key</mat-icon>
                <span>Resetar a Senha</span>
              </button>
              <!-- Botão da Dashboard de comissões dentro do Menu -->
              <button
                *ngIf="showDashboardButton && isInsideMenu('DashboardButton')"
                (click)="dashboard.emit(element)"
                mat-menu-item
                class="btn-dashboard">
                <mat-icon class="btn-dashboard">dashboard</mat-icon>
                <span>Dashboard de Comissões</span>
              </button>
              <!-- Botão de Download dentro do Menu -->
              <button
                *ngIf="showDownload && element[downloadProperty] && isInsideMenu('DownloadButton')"
                (click)="download.emit({ fileUrl: element[downloadProperty], element })"
                mat-menu-item
                class="btn-download"
                [disabled]="loadingDownloads[element.id]">
                <mat-icon
                  *ngIf="!loadingDownloads[element.id]"
                  class="btn-download">download</mat-icon>
                <mat-progress-spinner
                  *ngIf="loadingDownloads[element.id]"
                  class="mat-progress-spinner"
                  matTooltip="progresso de download"
                  [value]="loadingProgress[element.id]"
                  diameter="24"
                  mode="determinate"></mat-progress-spinner>
              </button>

              <!-- Novos Botões para Briefing dentro do Menu -->
              <button mat-menu-item
                *ngIf="showBriefingActions && isInsideMenu('BriefingActionsButton')"
                (click)="openBriefingQrCode.emit(element)">
                <mat-icon>qr_code</mat-icon>
                <span>Gerar QR Code</span>
              </button>

              <button mat-menu-item
                *ngIf="showBriefingActions && isInsideMenu('BriefingActionsButton')"
                (click)="openBriefingForm.emit(element)">
                <mat-icon>link</mat-icon>
                <span>Abrir Formulário</span>
              </button>
              <!-- Fim Botões para Briefing-->

              <button
                *ngIf="loadingDownloads[element.id]"
                (click)="cancelDownload.emit(element)"
                mat-icon-button
                class="btn-cancel">
                <mat-icon>cancel</mat-icon>
              </button>

              <!-- Botão de play dentro do Menu -->
              <button
                *ngIf="showPlayButton && isInsideMenu('PlayButton')"
                mat-menu-item color="primary"
                (click)="playRow(element)">
                <mat-icon color="primary">play_arrow</mat-icon>
                <span>Play</span>
              </button>
              <!-- Botão de PDF dentro do Menu -->
              <button
                *ngIf="showPdfButton && isInsideMenu('PdfButton') && element.status !== 'CANCELADA'&& element.status !== 'REPROVADA'"
                mat-menu-item color="primary"
                (click)="pdfShow(element)">
                <mat-icon color="primary">{{ pdfButtonIcon }}</mat-icon>
                <span>{{ pdfButtonLabel }}</span>
              </button>
              <!-- Botão para Visualizar Contratos dentro do Menu -->
              <button
                *ngIf="showContractsButton && isInsideMenu('ContractsButton')"
                (click)="openContracts(element)"
                mat-menu-item
                class="btn-contracts">
                <mat-icon class="btn-contracts">description</mat-icon>
                <span>Visualizar Contratos</span>
              </button>

              <!-- Botão de WhatsApp dentro do Menu -->
              <button
                *ngIf="showWhatsApp && isInsideMenu('WhatsAppButton')"
                mat-menu-item
                class="btn-whatsapp"
                (click)="onWhatsApp(element)">
                <img src="assets/img/whatsapp.svg"
                  style="width: 30px; height: 30px;" class="whatsapp-icon">
                <span>WhatsApp</span>
              </button>

              <!-- Botão de Email dentro do Menu-->
              <button
                *ngIf="showEmail && isInsideMenu('EmailButton')"
                mat-menu-item
                class="btn-email"
                (click)="onEmail(element)">
                <mat-icon class="btn-email">email</mat-icon>
                <span>Email</span>

              </button>

              <!-- Botão de Atividades dentro do Menu -->
              <button
                *ngIf="showActivities && isInsideMenu('ActivitiesButton')"
                mat-menu-item
                class="btn-activities"
                (click)="onActivities(element)">
                <mat-icon class="btn-activities">event_note</mat-icon>
                <span>Atividades</span>
              </button>

              <!-- Botão de Transações dentro do Menu -->
              <button
                *ngIf="showTransactions && isInsideMenu('TransactionsButton')"
                mat-menu-item
                class="btn-transactions"
                (click)="openTransactions.emit(element)">
                <mat-icon class="btn-transactions">receipt_long</mat-icon>
                <span>Transações</span>
              </button>
              <!-- Botão de Aniversário dentro do Menu -->
              <button
                *ngIf="showBirthday && isInsideMenu('BirthdayButton') && (!birthdayFilter || birthdayFilter(element))"
                mat-menu-item
                class="btn-birthday"
                (click)="onBirthday(element)">
                <mat-icon class="btn-birthday">cake</mat-icon>
                <span>Aniversário</span>
              </button>
              <!-- Botões Para Ativar e Desativar dentro do Menu -->
              <button
                *ngIf="showActive && element[activeProperty] && isInsideMenu('ActiveButton')"
                (click)="inactive.emit(element)"
                mat-menu-item
                class="btn-inactive">
                <mat-icon class="btn-inactive">remove_circle</mat-icon>
                <span>Desativar</span>
              </button>
              <button
                *ngIf="showActive && !element[activeProperty] && isInsideMenu('ActiveButton')"
                (click)="active.emit(element)"
                mat-menu-item
                class="btn-active">
                <mat-icon class="btn-active">check_circle</mat-icon>
                <span>Ativar</span>
              </button>

              <!-- Botão para alternar status (ativar/desativar) dentro do Menu -->
              <button
                *ngIf="showStatus && isInsideMenu('StatusButton')"
                mat-menu-item
                [class]="element[statusProperty] ? 'btn-status-active' : 'btn-status-inactive'"
                [matTooltip]="element[statusProperty] ? 'Desativar contato' : 'Ativar contato'"
                (click)="onToggleStatus(element)">
                <mat-icon *ngIf="element[statusProperty]">toggle_on</mat-icon>
                <mat-icon *ngIf="!element[statusProperty]"
                  class="inactive-icon">toggle_off</mat-icon>
              </button>

              <!-- Botão de Remoção dentro do Menu -->
              <button
                *ngIf="showRemoveButton && isInsideMenu('RemoveButton')"
                mat-menu-item
                class="btn-remove"
                (click)="onRemoveButtonClick(element)">
                <mat-icon class="btn-remove">remove</mat-icon>
                <span>Remover da seção</span>
              </button>
              <!-- Botão para Visualizar dentro do Menu -->
              <button mat-menu-item
                *ngIf="!element.hideShow && !hideShowButton && isInsideMenu('ShowButton')"
                (click)="showRow(element, row)">
                <mat-icon
                  class="btn-show">
                  remove_red_eye
                </mat-icon>
                <span>Visualizar</span>
              </button>

              <!-- Botão para editar dentro do Menu -->
              <button
                mat-menu-item
                *ngIf="!element.hideEdit && isEditableShow && isInsideMenu('EditButton')"
                [disabled]="!isEditableEnabled"
                class="btn-edit"
                (click)="isEditableEnabled && editRow(element, row)">
                <mat-icon
                  class="btn-edit"
                  [ngClass]="isEditableEnabled ? 'btn-edit' : 'btn-edit:disabled'">
                  edit
                </mat-icon>
                <span>Editar</span>
              </button>
              <!-- Botão de Excluir dentro do Menu -->
              <button
                mat-menu-item
                *ngIf="!element.hideDelete && isDeletableShow && isInsideMenu('DeleteButton')"
                [disabled]="!isDeletableEnabled"
                class="btn-delete"
                (click)="isDeletableEnabled && deleteRow(element, row)">
                <mat-icon
                  class="btn-delete"
                  [ngClass]="isDeletableEnabled ? 'btn-delete' : 'btn-delete:disabled'">
                  delete
                </mat-icon>
                <span>Excluir</span>
              </button>
              <!-- Botões para Bloquear e Desbloquear dentro do menu -->
              <button
                *ngIf="showLock && isInsideMenu('LockButton') && isLockActionShow && element[lockProperty] && element.status !== 'CANCELADA' && element.status !== 'REPROVADA' && element.status !== 'CONCLUIDA'"
                [disabled]="!isLockActionEnabled"
                (click)="isLockActionEnabled && lock.emit(element)"
                mat-menu-item
                class="btn-lock">
                <mat-icon class="btn-lock">lock</mat-icon>
                <span>Bloquear</span>
              </button>
              <button
                *ngIf="showLock && isInsideMenu('LockButton') && isLockActionShow && !element[lockProperty] && element.status !== 'CANCELADA' && element.status !== 'REPROVADA' && element.status !== 'CONCLUIDA'"
                [disabled]="!isLockActionEnabled"
                (click)="isLockActionEnabled && unlock.emit(element)"
                mat-menu-item
                class="btn-unlock">
                <mat-icon class="btn-unlock">lock_open</mat-icon>
                <span>Desbloquear</span>
              </button>
              <button
                *ngIf="showPeopleLock && element[lockPeopleProperty] && isInsideMenu('PeopleLockButton')"
                (click)="lockPeople.emit(element)"
                mat-menu-item
                class="btn-lock">
                <mat-icon class="btn-lock">people</mat-icon>
                <span>Bloquear Pessoa</span>
              </button>
              <button
                *ngIf="showPeopleLock && !element[lockPeopleProperty] && isInsideMenu('PeopleLockButton')"
                (click)="unlockPeople.emit(element)"
                mat-menu-item
                class="btn-unlock">
                <mat-icon class="btn-unlock">people</mat-icon>
                <span>Desbloquear Pessoa</span>
              </button>
              <!-- Botão para ver Detalhes dentro do Menu -->
              <button
                *ngIf="showInfo && isInsideMenu('InfoButton') && element[infoProperty] || element.planDescription "
                (click)="infoAction.emit(element)"
                mat-menu-item
                class="btn-info">
                <mat-icon class="btn-info">info</mat-icon>
                <span>Detalhes</span>
              </button>
              <!-- Botão para Realizar Pagamento dentro do Menu -->
              <button
                *ngIf="showPaymentButton && canShowPaymentButton(element) && isInsideMenu('PaymentButton')"
                (click)="openPayment(element)"
                mat-menu-item
                class="btn-payment"
                [disabled]="element.isPaid === true">
                <mat-icon class="btn-payment">{{ paymentButtonIcon }}</mat-icon>
                <span>Realizar Pagamento</span>
              </button>
              <!-- Botão para Colocar Foto de documento dentro do Menu -->
              <button
                *ngIf="showDocumentPhoto && isInsideMenu('DocumentPhotoButton')"
                (click)="DocumentPhoto.emit(element)"
                mat-menu-item
                class="btn-info">
                <mat-icon>camera_alt</mat-icon>
                <span>Foto do Documento</span>
              </button>

              <!-- Botão de Cancelar Parcela dentro do Menu -->
              <button
                *ngIf="showCancelButton && isInsideMenu('CancelButton')"
                (click)="cancelParcel.emit(element)"
                mat-menu-item
                class="btn-cancel">
                <mat-icon class="btn-cancel">cancel</mat-icon>
                <span>Cancelar Parcela</span>
              </button>
              <button
                *ngIf="showRegisterAswersButton && canShowChatButton(element) && isInsideMenu('RegisterAswersButton') 
                && (element['briefing.typeDescription'] === 'CADASTRO DO CLIENTE' || element['briefing.typeDescription'] === 'CADASTRO DE PARCEIRO')"
                mat-menu-item color="primary" class="btn-inside-menu"
                (click)="RegisterCustomers(element)">
                <mat-icon>save</mat-icon>
                <span>Gerar Cadastro</span>
              </button>
            </mat-menu>

            <div class="dropdown-list" *ngIf="selectedItems.length === 0">
              <div *ngIf="showViewButton" (click)="view.emit(item)"
                class="dropdown-item">
                <mat-icon>visibility</mat-icon>
                <span>Visualizar</span>
              </div>
              <!-- Removendo os itens que foram movidos para a linha principal -->
              <div *ngIf="showEditButton" (click)="edit.emit(item)"
                class="dropdown-item">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </div>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="(hasSelectConfig() && enableRowClickSelection) ? toggleRowSelection(row) : onSelect.emit({ select: true, row })"
          [ngClass]="[
            typeIndexEnum.SELECT === type ? 'cursor-pointer' : 'cursor-normal',
            showStatus && !row[statusProperty] ? 'inactive-row' : '',
            row.hasOverdueBills ? 'overdue-row' : '',
            hasSelectConfig() && selection.isSelected(row) ? 'selected-row' : '',
            row.rowClass || ''
          ]"></tr>
      </table>
    </div>

    <mat-paginator
      *ngIf="!hidePagination"
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent($event)"></mat-paginator>

    <ng-content select="[footer]"></ng-content>

  </div>

  <!-- <mat-menu #menu="matMenu">
  <button mat-menu-item>
    <mat-icon>edit</mat-icon>
    <span>Editar</span>
  </button>
  <button mat-menu-item disabled>
    <mat-icon>delete</mat-icon>
    <span>Remover</span>
  </button>
</mat-menu> -->
</div>
